import React from 'react';

const formattedLocation = (asset, props) => {
  const lineBreak = props?.lineBreak;

  if (!asset) { return null; }
  if (asset.location) { asset = asset.location; }

  let retval = asset.city;
  if (retval && asset.state) {
    retval = `${retval}, ${asset.state}`;
  }

  if (asset.postalCode?.formatted) {
    retval = `${retval} ${asset.postalCode?.formatted}`;
  };

  if (asset.street) {
    if (lineBreak) {
      return <>{asset.street}<br />{retval}</>;
    } else {
      return `${asset.street}, ${retval}`;
    }
  } else {
    return retval;
  }
};

export const formattedConsignmentLocation = (asset, props) => {
  const lineBreak = props?.lineBreak;

  if (!asset) { return null; }

  if(asset.consignmentMethod === 'Pickup' && asset.customConsignmentAddress) {
    return asset.customConsignmentAddress
  }else {
    if (asset.consignmentLocation) { asset = asset.consignmentLocation; }

    let retval = asset.city;
    if (retval && asset.state) {
      retval = `${retval}, ${asset.state}`;
    }

    if (asset.postalCode?.formatted) {
      retval = `${retval} ${asset.postalCode?.formatted}`;
    };

    if (asset.street) {
      if (lineBreak) {
        return <>{asset.street}<br />{retval}</>;
      } else {
        return `${asset.street}, ${retval}`;
      }
    } else {
      return retval;
    }
  }
};

export default formattedLocation;
